module.exports = "/images/settings.svg?15f0647a86bd1f8a77ee19b347470cd7";